import { render, staticRenderFns } from "./FaqDirectLinks.vue?vue&type=template&id=06c1829c&"
import script from "./FaqDirectLinks.vue?vue&type=script&lang=js&"
export * from "./FaqDirectLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports